import { InjectionToken } from '@angular/core';

export const SEARCH_CONDITION = new InjectionToken('SearchCondition');
export const SEARCH_EXPRESSION = new InjectionToken('SearchExpression');

export const SearchCriteriaTokens = {
  SearchCondition: SEARCH_CONDITION,
  SearchExpression: SEARCH_EXPRESSION
};
